"use client";

import createIcon from './util/createIcon';
export default createIcon('M13,7.2V17.74L13,20.44L12,21.35L10.55,20.03C5.4,15.36 2,12.27 2,8.5C2,5.41 4.42,3 7.5,3C10,3 13,5 13,7.2Z', 'HeartHalf');